// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{margin:0;font-family:Vinci Sans Light,Vinci Sans,Arial,sans-serif;background:#fafafa}body,input{padding:0}", ""]);
// Exports
module.exports = exports;
